import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

@Component({
	selector: 'cv-row-array',
	templateUrl: './row-array.component.html',
	styleUrls: ['./row-array.component.scss'],
})
export class RowArrayComponent {
	@Input() field;
	@Input() arrayChilds;

	@Output() addFormArray = new EventEmitter<any>();
	@Output() deleteFormArray = new EventEmitter<any>();

	deleteChild(index) {
		this.deleteFormArray.emit({index});
	}

	createChild() {
		this.addFormArray.emit({createFormControls: true});
	}
}
